import { render, staticRenderFns } from "./FaqsContainer.vue?vue&type=template&id=7c13ccfd&scoped=true&"
import script from "./FaqsContainer.vue?vue&type=script&lang=js&"
export * from "./FaqsContainer.vue?vue&type=script&lang=js&"
import style0 from "./FaqsContainer.vue?vue&type=style&index=0&id=7c13ccfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13ccfd",
  null
  
)

export default component.exports